import type { Me } from '../api';

/** True if this admin may access a dashboard module (super admin bypasses). */
export function adminCanAccess(
  me: Pick<Me, 'isSuperAdmin' | 'permissions'> | null | undefined,
  module: string,
): boolean {
  if (!me) return false;
  if (me.isSuperAdmin) return true;
  return (me.permissions ?? []).some(p => p.startsWith(`${module}:`));
}
